module.exports = __webpack_public_path__ + "static/media/isdoctorplan-gastro1@3x.6bf47cc5.png";